import Util from '../utils/Helpers';
const redirectUrl = Util.isLocalhost() ? 'http://localhost:9393/auth/login-gov/login/loa-1' : '/auth/auth';

export const authMiddleware = () => {
	return (next) => {
		return (action) => {
			if (action && action.type === 'FETCH_USER_DATA_FAILED') {
				window.location.assign(redirectUrl);
			}
			next(action);
		};
	};
};
